export default __webpack_public_path__ + "static/media/ReferClaim.f5dabe32.svg";